import { render, staticRenderFns } from "./audio_item.vue?vue&type=template&id=048a3b5c&scoped=true&"
import script from "./audio_item.vue?vue&type=script&lang=js&"
export * from "./audio_item.vue?vue&type=script&lang=js&"
import style0 from "./audio_item.vue?vue&type=style&index=0&id=048a3b5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048a3b5c",
  null
  
)

export default component.exports